import { render } from "./BCol.vue?vue&type=template&id=1c9f6425&ts=true"
import script from "./BCol.vue?vue&type=script&lang=ts"
export * from "./BCol.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__